<template>
 <div>
   <div class="row vehicle-type-chart-header">
      <div class="col-md-12">
        <div class="chart-head-container">
          <h2>
            Aggregate Statistics
            <button v-tooltip title="Statistics are calculated on a daily basis" class="btn btn-tooltip ms-2"><font-awesome-icon icon="fa-solid fa-question-circle" /></button>
          </h2>
        </div>
      </div>
      <div class="col-md-10 multiple-dropdown">
        <label for="chart-select">Select charts</label>
        <VueMultiselect
          id="chart-select"
          v-model="selected"
          track-by="id"
          label="name"
          :options="options"
          @open="openMultiselect('chart-select')"
          @close="closeMultiselect('chart-select')"
          :multiple="true">
        </VueMultiselect>
      </div>
    </div>
    <div>
    </div>
    <div class="row" v-if="hasHistData">
      <div class="col-md-6 hist-chart" v-for="chart in chartIds" :key="chart">
      <div v-if="histogramData[chart]">
        <Histogram :hist-data = histogramData[chart] />
      </div>
      <div v-else>
       The chart "{{chartNames[chart]}}" has no data for the selected vocation and weight class
      </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import VueMultiselect from 'vue-multiselect';
import Histogram from '@/components/HistoGram.vue';
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';

const router = useRouter();
const route = useRoute();
const store = useStore();
const options = computed(() => store.getters.getAggregateDropdownData);
const chartNames = computed(() => store.getters.getAllChartNames);

onMounted(() => {
  document.querySelector('div[aria-owns="listbox-chart-select"').setAttribute('aria-expanded', false);
});

function openMultiselect(selectId) {
  document.querySelector(`div[aria-owns="listbox-${selectId}"`).setAttribute('aria-expanded', true);
}

function closeMultiselect(selectId) {
  document.querySelector(`div[aria-owns="listbox-${selectId}"`).setAttribute('aria-expanded', false);
}

const selected = computed({
  get: () => store.getters.getSelectedCharts,
  set: (value) => {
    const selectedArr = value.map((chart) => chart.id);
    router.push({
      query: {
        ...route.query,
        chart: selectedArr,
      },
    });
  },
});

const histogramData = computed(() => store.getters.getHistogramData);
const hasHistData = computed(() => Object.keys(histogramData).length >= 1);

const chartIds = computed(() => {
  const selectedValues = selected.value;
  return selectedValues.map((chart) => chart.id);
});
</script>
